import { render, staticRenderFns } from "./reservations.vue?vue&type=template&id=430f1b6c&"
import script from "./reservations.vue?vue&type=script&lang=ts&"
export * from "./reservations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports